import React, { useEffect, useRef } from 'react'

declare global {
  interface Window {
    YT: any
    onYouTubeIframeAPIReady: any
  }
}

const YouTubePlayer = ({
  videoId,
  startTime = 0,
  onStop,
  width,
  height,
  id = '',
  style = {},
}) => {
  const playerRef = useRef(null)

  useEffect(() => {
    if (!window.YT) {
      window.onYouTubeIframeAPIReady = () => createPlayer()
    } else {
      createPlayer()
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    //resize player
    if (playerRef.current) {
      playerRef.current.setSize(width, height)
    }
  }, [width, height])

  const createPlayer = () => {
    playerRef.current = new window.YT.Player(`yt-player-${videoId}` + id, {
      videoId: videoId,
      width: width,
      height: height,
      playerVars: {
        start: startTime,
      },
      events: {
        onReady: () => {
          onStop && onStop(() => playerRef.current.pauseVideo())
        },
      },
    })
  }

  return (
    <div
      style={{ marginBottom: '20px', ...style }}
      id={`yt-player-${videoId}` + id}
    />
  )
}

export default YouTubePlayer
